import React, { useState, useEffect } from 'react';
import { backend_url } from '../../App';

const DEFAULT_BRANDS = [
  { name: 'Apple',     icon: '🍎' },
  { name: 'Samsung',   icon: '📱' },
  { name: 'Dell',      icon: '💻' },
  { name: 'HP',        icon: '🖥️' },
  { name: 'Lenovo',    icon: '⌨️' },
  { name: 'Sony',      icon: '🎧' },
  { name: 'LG',        icon: '📺' },
  { name: 'Asus',      icon: '🖱️' },
  { name: 'Xiaomi',    icon: '📡' },
  { name: 'Huawei',    icon: '📶' },
  { name: 'OnePlus',   icon: '🔴' },
  { name: 'JBL',       icon: '🔊' },
  { name: 'Razer',     icon: '🎮' },
  { name: 'Microsoft', icon: '🪟' },
];

const BrandsMarquee = () => {
  const [brandList, setBrandList] = useState(DEFAULT_BRANDS);

  useEffect(() => {
    fetch(`${backend_url}/homecontent`)
      .then(r => r.json())
      .then(data => { if (data.brands?.length) setBrandList(data.brands); })
      .catch(() => {});
  }, []);

  const list = [...brandList, ...brandList];
  return (
    <section className="py-12 border-t border-white/[0.05] overflow-hidden">
      <p className="text-center text-[#2a3547] text-[10px] font-bold tracking-[3px] uppercase mb-8">Trusted Brands We Carry</p>
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-28 z-10 pointer-events-none" style={{ background: 'linear-gradient(90deg, #060c18 0%, transparent 100%)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-28 z-10 pointer-events-none" style={{ background: 'linear-gradient(-90deg, #060c18 0%, transparent 100%)' }} />

        <div className="flex animate-scroll-x" style={{ width: 'max-content' }}>
          {list.map((b, i) => (
            <div
              key={i}
              className="group flex-shrink-0 flex items-center gap-3 mx-3 px-6 py-3.5 rounded-2xl cursor-default transition-all duration-300 hover:scale-105"
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}
            >
              <span className="text-xl transition-transform duration-300 group-hover:scale-110">{b.icon}</span>
              <span className="text-[#4a5568] font-bold text-sm tracking-wide group-hover:text-[#8896a6] transition-colors whitespace-nowrap">{b.name}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll-x {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-x {
          animation: scroll-x 35s linear infinite;
        }
        .animate-scroll-x:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandsMarquee;
